import React from 'react';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { envUtils } from '@ft-frontend/core';

export default function PosaleFooter({
  footerLeftContent,
  footerRightContent,
}) {
  return (
    <Grid
      sx={{
        backgroundColor: 'white',
        padding: '0px 16px',
        borderTop: '1px solid #e9e9e9',
        minHeight: '80px',
        displayPrint: 'none',
        position: 'relative',
        maxWidth: '2560px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
      component='footer'
      container
      justifyContent='center'
    >
      <Grid item xs={4} alignContent='center'>
        {footerLeftContent}
      </Grid>
      <Grid
        item
        container
        xs={4}
        justifyContent='center'
        alignItems='center'
        spacing={1}
        direction='column'
      >
        <img
          src={`${envUtils.getCDNBaseURL()}Techdata/TDSYNNEX-transparent.svg`}
          alt='TD SYNNEX'
          data-testid='footer-td-synnex-logo'
          width='101px'
          height='24px'
        />
        <Stack spacing={0} alignItems='center'>
          <Typography
            variant='caption'
            color='gray.dark'
          >{`Copyright © ${new Date().getFullYear()} - All Rights Reserved`}</Typography>
          <Typography
            variant='caption'
            color='gray.dark'
          >{`version #${process.env.REACT_APP_SENTRY_RELEASE}`}</Typography>
        </Stack>
      </Grid>
      <Grid item xs={4} alignContent='center' textAlign='right'>
        {footerRightContent}
      </Grid>
    </Grid>
  );
}
